import { VStack, Divider } from '@wegroup/design-system';
import React from 'react';
import CompanyScanContentWrapper from '../../../../flows/src/components/ui/company-scan/components/app-shell/CompanyScanContentWrapper';
import WelcomeForm from './WelcomeForm';
import WelcomeHeader from './WelcomeHeader';
import WelcomeText from './WelcomeText';

const WelcomeContent: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <CompanyScanContentWrapper justifyContent="center">
      <VStack align="stretch" spacing="6" maxW="xl">
        <WelcomeHeader />
        <VStack
          spacing="6"
          divider={<Divider borderColor="gray.50" />}
          align="stretch"
        >
          <WelcomeText />
          <WelcomeForm />
        </VStack>
      </VStack>
    </CompanyScanContentWrapper>
  );
};

export default WelcomeContent;
